import { templateLicenseMonthlyTrialSubForm } from '../view/template';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { LicenseMonthlyLicenseTrialSubFormWebComponent } from '../component/LicenseMonthlyLicenseTrialSubFormWebComponent';
import { LicenseMonthlyLicenseTrialSubFormView } from '../view/LicenseMonthlyLicenseTrialSubFormView';

export class LicenseMonthlyLicenseTrialSubFormController extends BaseWebComponentController {
  public component: LicenseMonthlyLicenseTrialSubFormWebComponent;
  public view: LicenseMonthlyLicenseTrialSubFormView;
  public viewConstructor: typeof LicenseMonthlyLicenseTrialSubFormView;

  constructor(component: LicenseMonthlyLicenseTrialSubFormWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: LicenseMonthlyLicenseTrialSubFormView,
      viewTemplate: templateLicenseMonthlyTrialSubForm,
    });
  }
}
